import { Link } from 'react-router-dom';

export default function ServicesHero() {
  return (
    <section className="relative min-h-[72vh] flex items-center overflow-hidden bg-[#F8F5F0]">
      {/* Right side image */}
      <div className="absolute top-0 right-0 w-[50%] h-full hidden lg:block">
        <img
          src="https://readdy.ai/api/search-image?query=modern%20architectural%20blueprint%20technical%20drawing%20on%20desk%20with%20compass%20ruler%20professional%20workspace%20warm%20light%20overhead%20view%20clean%20minimal%20design%20studio&width=900&height=800&seq=svchero2001&orientation=squarish"
          alt="服務項目 保險建築師"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#F8F5F0] via-[#F8F5F0]/50 to-transparent"></div>
      </div>

      {/* Subtle dot pattern */}
      <div className="absolute inset-0 opacity-[0.04]"
        style={{ backgroundImage: 'radial-gradient(#5C5470 1px, transparent 1px)', backgroundSize: '24px 24px' }}>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-10 pt-28 pb-20">
        <div className="max-w-[560px]">
          <div className="inline-flex items-center gap-2 bg-[#5C5470]/10 border border-[#5C5470]/20 rounded-full px-4 py-2 mb-8">
            <span className="w-2 h-2 rounded-full bg-[#D4A373]"></span>
            <span className="text-[#5C5470] font-medium" style={{ fontSize: '1rem' }}>人生風險結構規劃</span>
          </div>

          <h1
            className="font-serif font-bold text-[#5C5470] mb-6"
            style={{ fontSize: 'clamp(2rem, 4vw, 2.75rem)', lineHeight: '1.3' }}
          >
            服務項目
            <br />
            <span className="text-[#D4A373]">為不同人生階段，</span>
            <br />
            搭好保障結構
          </h1>

          <p
            className="text-[#5C5470]/75 mb-10"
            style={{ fontSize: '1.1875rem', lineHeight: '1.75' }}
          >
            從個人醫療、家庭保障、長期照護到企業團體方案，
            保險建築師協助您把風險看清楚、把保障配置好。
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 bg-[#D4A373] text-white px-8 py-4 rounded-full font-semibold whitespace-nowrap hover:bg-[#c4935f] transition-all duration-200 hover:scale-105"
              style={{ fontSize: '1.1875rem' }}
            >
              <i className="ri-chat-3-line"></i>
              立即諮詢
            </Link>
            <a
              href="#health-check-section"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('health-check-section')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center justify-center gap-2 border-2 border-[#5C5470] text-[#5C5470] px-8 py-4 rounded-full font-semibold whitespace-nowrap hover:bg-[#5C5470] hover:text-white transition-all duration-200 cursor-pointer"
              style={{ fontSize: '1.1875rem' }}
            >
              <i className="ri-file-search-line"></i>
              免費保單健檢
            </a>
          </div>

          {/* Mobile image */}
          <div className="mt-12 lg:hidden rounded-2xl overflow-hidden aspect-[16/9]">
            <img
              src="https://readdy.ai/api/search-image?query=modern%20architectural%20blueprint%20technical%20drawing%20on%20desk%20with%20compass%20ruler%20professional%20workspace%20warm%20light%20overhead%20view%20clean%20minimal%20design%20studio&width=800&height=450&seq=svchero2003&orientation=landscape"
              alt="服務項目"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
